import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withRouter from "../components/Common/withRouter";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NonAuthLayout = (props) => {
  const navigate = useNavigate()
  const { user } = useSelector(state => ({
    user: state.login.user,
  }));

  useEffect(() => {
    if(user) navigate("/")
  }, [])
  
  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
};

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
};

export default withRouter(NonAuthLayout);
